import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
    selector: 'options',
    templateUrl: './options.html',
})
export class OptionsComponent {
    public analytic: boolean;

    constructor(
        private viewCtrl: ViewController,
        navParams: NavParams
    ) {
        this.analytic = navParams.get('analytic');
    }

    public share(analytic: boolean): void {
        this.viewCtrl.dismiss(analytic);
    }
}


// WEBPACK FOOTER //
// ./src/components/options/options.ts